// Wave-J (loop-engineering nota-10) — RESUME-NOT-RESTART: marker do run em
// andamento sobrevive a crash/fechamento do app. No boot da sessão, um run que
// morreu no meio vira aviso + retomada em 1 palavra ("continuar" já expande com
// contexto via expandContinuePrompt; o INIT da LEI lê .apolo/progress.md).
// localStorage best-effort — nunca derruba o run.

const KEY = (sessionId) => `apolo:runInFlight:v1:${sessionId}`;

export function markRunStart(sessionId, taskText) {
  try {
    if (!sessionId) return;
    window.localStorage?.setItem(KEY(sessionId), JSON.stringify({
      taskText: String(taskText || '').slice(0, 200),
      startedAt: new Date().toISOString(),
    }));
  } catch { /* best-effort */ }
}

export function clearRunMark(sessionId) {
  try { if (sessionId) window.localStorage?.removeItem(KEY(sessionId)); } catch { /* noop */ }
}

/** Devolve o marker órfão (run que morreu sem fechar) ou null. Consome (limpa) ao ler. */
export function takeOrphanRunMark(sessionId) {
  try {
    if (!sessionId) return null;
    const raw = window.localStorage?.getItem(KEY(sessionId));
    if (!raw) return null;
    window.localStorage.removeItem(KEY(sessionId));
    const mark = JSON.parse(raw);
    return mark && typeof mark.taskText === 'string' ? mark : null;
  } catch { return null; }
}

/** Mensagem de retomada exibida na sessão quando há marker órfão. */
export function buildResumeNotice(mark) {
  return [
    `⚠️ Um run foi interrompido no meio (app fechou/crashou) — tarefa: "${mark.taskText}".`,
    'O estado parcial está no worktree (.apolo/progress.md, commits e arquivos já escritos).',
    'Digite "continuar" para retomar de onde parou — o agente relê o progresso antes de agir.',
  ].join('\n');
}
